import React, { Component } from "react";
import {
  PageHeader,
  Input,
  Row,
  Col,
  Radio,
  Button,
  Tooltip,
  Tabs,
  Select,
} from "antd";
import { withRouter } from "react-router-dom";
import {
  PlusOutlined,
  SaveOutlined,
  UndoOutlined,
  FileOutlined,
  CodeOutlined,
  DeleteOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import Axios from "../../../config/axios";
import "../../../style.css";
import "./style.css";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Loading from "../../../components/Loading";
import TextArea from "antd/lib/input/TextArea";
import { baseUrl } from "../../../config/urls";

const pretty = require("pretty");

class AddLetter extends Component {
  state = {
    letterID: "",
    letter: {
      title: "",
      type: "",
      description: "",
      fields: [],
      response_fields: [],
      template: "",
      response_template: "",
      signature_type: "",
      thesis: false,
      thesis_defence: false,
      thesis_submission: false,
      default_addressed: "",
      letterhead_type: "",
    },
    form: {
      title: "",
      // letter_code: "",
      type: "",
      fields: [],
      description: "",
      response_fields: [],
      template: "",
      response_template: "",
      signature_type: "",
      thesis: false,
      thesis_defence: false,
      thesis_submission: false,
      default_addressed: "",
      letter_users: [],
      letterhead_type: "",
    },
    errors: {},
    units: [],
  };

  componentDidMount() {
    if (this.props.match.params.id) {
      this.setState({ letterID: this.props.match.params.id }, () =>
        this.fetchLetter()
      );
    }
    this.fetchUnits();
  }

  fetchLetter = () => {
    Axios.get("/letters/" + this.state.letterID).then((response) => {
      const letter = { ...response.data };
      this.setState({ letter, form: response.data });
    });
  };

  fetchUnits = () => {
    Axios.get("/units").then((response) => {
      const units = response.data.payload[0].children;
      const filteredUnits = units.filter((unit) => unit.type === "Fakultas");
      this.setState({ units: filteredUnits });
    });
  };

  resetForm = () => {
    const form = { ...this.state.letter };
    this.setState({ form, errors: {} });
  };

  handleAddField = () => {
    const { form } = this.state;
    form.fields = [
      ...form.fields,
      {
        name: "",
        placeholder: "",
        label: "",
      },
    ];
    this.setState({ form });
  };

  handleAddResponseField = () => {
    const { form } = this.state;
    form.response_fields = [
      ...form.response_fields,
      {
        name: "",
        placeholder: "",
        label: "",
      },
    ];
    this.setState({ form });
  };

  handleChangeForm = (e) => {
    let { form } = this.state;
    if (
      [
        "thesis",
        "thesis_defence",
        "thesis_submission",
        "use_letter_number",
      ].includes(e.target.name)
    ) {
      form[e.target.name] = e.target.value === "1" ? true : false;
    } else {
      form[e.target.name] = e.target.value;
    }
    this.setState({ form, errors: {} });
  };

  handleChangeSelect = (value) => {
    let { form } = this.state;
    form.default_addressed = value;
    this.setState({ form, errors: {} });
  };

  handlePretty = (name, text) => {
    let { form } = this.state;
    form[name] = pretty(text);
    this.setState({ form });
  };

  handleChangeField = (e) => {
    let { form } = this.state;
    let fields = form.fields;
    const key = e.target.name.split("-");
    fields[key[1]][key[0]] = e.target.value;
    this.setState({ form, errors: {} });
  };

  handleChangeResponseField = (e) => {
    let { form } = this.state;
    let response_fields = form.response_fields;
    const key = e.target.name.split("-");
    response_fields[key[1]][key[0]] = e.target.value;
    this.setState({ form, errors: {} });
  };

  handleSubmit = () => {
    const { form } = this.state;
    delete form._id;
    // form.letter_code = form.letter_code.toUpperCase();
    Axios.request({
      method: this.state.letterID ? "PUT" : "POST",
      url:
        "/letters/save" +
        (this.state.letterID ? "/" + this.state.letterID : ""),
      data: form,
    })
      .then(() => {
        this.props.history.push({
          pathname: "/admin/master-surat",
          state: {
            message: this.state.letterID
              ? "Surat Berhasil Diubah"
              : "Surat Berhasil Ditambah",
            type: "success",
            tabKey: "1",
          },
        });
      })
      .catch((errors) => {
        this.setState({ errors: errors.data });
      });
  };

  handleDeleteField = (index) => {
    const { form } = this.state;
    form.fields.splice(index, 1);
    this.setState({ form });
  };

  handleDeleteResponseField = (index) => {
    const { form } = this.state;
    form.response_fields.splice(index, 1);
    this.setState({ form });
  };

  handleOnChangeFaculty = (value) => {
    const { form } = this.state;
    form.letter_users = value;
    this.setState({ form });
  };

  render() {
    const { form } = this.state;

    return (
      <>
        <div className="site-layout-background" style={{ padding: 10 }}>
          <PageHeader
            className="site-page-header"
            onBack={() => this.props.history.push("/admin/master-surat")}
            title="Master Surat"
            subTitle="kelola surat Administrasi"
            extra={[
              <Button key="reset" onClick={this.resetForm}>
                <UndoOutlined /> Reset
              </Button>,
              <Button key="save" type="primary" onClick={this.handleSubmit}>
                <SaveOutlined /> <span>Simpan</span>
              </Button>,
            ]}
          />
        </div>

        <Row style={{ padding: 10 }}>
          <Col sm={24} md={10} lg={6}>
            <Col className="card-form mt-10">
              <h3>Keterangan</h3>
              <label>Nama Surat</label>
              <Input
                placeholder="Nama Surat"
                value={form.title}
                onChange={this.handleChangeForm}
                name="title"
              />
              {<span className="error-message">{this.state.errors.title}</span>}
              {/* <div className="mt-10">
                                <label>Kode Surat</label><br />
                                <Input
                                    placeholder="Kode Surat"
                                    value={form.letter_code}
                                    onChange={this.handleChangeForm}
                                    name="letter_code"
                                />                    
                            </div>
                            {<span className="error-message">{this.state.errors.type}</span>} */}
              <div className="mt-10">
                <label>Tipe Surat</label>
                <br />
                <Radio.Group
                  onChange={this.handleChangeForm}
                  name="type"
                  value={form.type}
                >
                  <Radio className="radio-style" value="akademik">
                    Akademik
                  </Radio>
                  <Radio className="radio-style" value="akademik2">
                    Akademik-Prodi
                  </Radio>
                  <Radio className="radio-style" value="kemahasiswaan">
                    Kemahasiswaan
                  </Radio>
                </Radio.Group>
              </div>
              {<span className="error-message">{this.state.errors.type}</span>}
              <div className="mt-10">
                <label>Tujuan Surat</label>
                <br />
                <Select
                  onChange={this.handleChangeSelect}
                  name="default_addressed"
                  value={form.default_addressed}
                  style={{ width: "100%" }}
                >
                  <Select.Option value="">Tidak Ada</Select.Option>
                  <Select.Option value="13">Dekan</Select.Option>
                  <Select.Option value="14">Wakil Dekan I</Select.Option>
                  <Select.Option value="15">Wakil Dekan II</Select.Option>
                  <Select.Option value="16">Wakil Dekan III</Select.Option>
                  <Select.Option value="23">
                    Kepala Sub Bagian Akademik
                  </Select.Option>
                  <Select.Option value="20">Ketua Program Studi</Select.Option>
                </Select>
              </div>
              {
                <span className="error-message">
                  {this.state.errors.default_addressed}
                </span>
              }
              <div className="mt-10">
                <label>Kop Surat</label>
                <br />
                <Radio.Group
                  onChange={this.handleChangeForm}
                  name="letterhead_type"
                  value={form.letterhead_type}
                >
                  <Radio className="radio-style" value="fakultas">
                    Fakultas
                  </Radio>
                  <Radio className="radio-style" value="prodi">
                    Prodi
                  </Radio>
                </Radio.Group>
              </div>
              {
                <span className="error-message">
                  {this.state.errors.letterhead_type}
                </span>
              }
              <div className="mt-10">
                <label>Pakai Nomor Surat</label>
                <br />
                <Radio.Group
                  onChange={this.handleChangeForm}
                  name="use_letter_number"
                  value={form.use_letter_number === true ? "1" : "0"}
                >
                  <Radio className="radio-style" value="1">
                    Ya
                  </Radio>
                  <Radio className="radio-style" value="0">
                    Tidak
                  </Radio>
                </Radio.Group>
              </div>
              {
                <span className="error-message">
                  {this.state.errors.use_letter_number}
                </span>
              }
              <div className="mt-10">
                <label>Tipe Signature</label>
                <br />
                <Radio.Group
                  onChange={this.handleChangeForm}
                  name="signature_type"
                  value={form.signature_type}
                >
                  <Radio className="radio-style" value="manual">
                    Manual
                  </Radio>
                  <Radio className="radio-style" value="digital">
                    Digital
                  </Radio>
                </Radio.Group>
              </div>
              {
                <span className="error-message">
                  {this.state.errors.signature_type}
                </span>
              }
              <div className="mt-10">
                <label>Seminar Skripsi/Tugas Akhir</label>
                <br />
                <Radio.Group
                  onChange={this.handleChangeForm}
                  name="thesis"
                  value={form.thesis ? "1" : "0"}
                >
                  <Radio className="radio-style" value="1">
                    Iya
                  </Radio>
                  <Radio className="radio-style" value="0">
                    Tidak
                  </Radio>
                </Radio.Group>
              </div>
              {<span className="error-message">{this.state.errors.type}</span>}
              <div className="mt-10">
                <label>Sidang Skripsi/Tugas Akhir</label>
                <br />
                <Radio.Group
                  onChange={this.handleChangeForm}
                  name="thesis_defence"
                  value={form.thesis_defence ? "1" : "0"}
                >
                  <Radio className="radio-style" value="1">
                    Iya
                  </Radio>
                  <Radio className="radio-style" value="0">
                    Tidak
                  </Radio>
                </Radio.Group>
              </div>
              {<span className="error-message">{this.state.errors.type}</span>}
              <div className="mt-10">
                <label>Penyerahan Skripsi</label>
                <br />
                <Radio.Group
                  onChange={this.handleChangeForm}
                  name="thesis_submission"
                  value={form.thesis_submission ? "1" : "0"}
                >
                  <Radio className="radio-style" value="1">
                    Iya
                  </Radio>
                  <Radio className="radio-style" value="0">
                    Tidak
                  </Radio>
                </Radio.Group>
              </div>
              {<span className="error-message">{this.state.errors.type}</span>}
              <label>Deskripsi</label>
              <TextArea
                placeholder="Deskripsi surat"
                value={form.description}
                onChange={this.handleChangeForm}
                name="description"
              />
              {
                <span className="error-message">
                  {this.state.errors.description}
                </span>
              }
              <div className="mt-10">
                <label>Unit Pengguna</label>
                <br />
                <Select
                  style={{ width: "100%" }}
                  mode="multiple"
                  allowClear
                  onChange={this.handleOnChangeFaculty}
                  value={form.letter_users}
                >
                  {this.state.units.map((unit) => (
                    <Select.Option key={unit.id} value={unit.value}>
                      {unit.name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </Col>

            <Col className="card-form mt-10">
              <Row>
                <Col>
                  <h3>Fields</h3>{" "}
                </Col>
                <Col style={{ position: "absolute", right: 20 }}>
                  <Tooltip title="Tambah Field">
                    <Button
                      shape="circle"
                      className="add-button"
                      onClick={this.handleAddField}
                    >
                      <PlusOutlined />
                    </Button>
                  </Tooltip>
                </Col>
              </Row>
              <Row className="mt-10">
                {form.fields.map((field, index) => (
                  <Row key={index}>
                    <Col className="mb-10" xs={22} sm={22} md={24} lg={18}>
                      <div>
                        <label>Label</label>
                        <Input
                          className="mb-5"
                          name={"label-" + index}
                          placeholder="label"
                          value={field.label}
                          onChange={this.handleChangeField}
                        />
                        {
                          <span className="error-message">
                            {this.state.errors["fields." + index + ".label"]}
                          </span>
                        }
                      </div>
                      <div>
                        <label>Placeholder</label>
                        <Input
                          className="mb-5"
                          name={"placeholder-" + index}
                          placeholder="placeholder"
                          value={field.placeholder}
                          onChange={this.handleChangeField}
                        />
                        {
                          <span className="error-message">
                            {
                              this.state.errors[
                                "fields." + index + ".placeholder"
                              ]
                            }
                          </span>
                        }
                      </div>
                      <div>
                        <label>Name</label>
                        <Input
                          className="mb-5"
                          name={"name-" + index}
                          placeholder="name"
                          value={field.name}
                          onChange={this.handleChangeField}
                        />
                        {
                          <span className="error-message">
                            {this.state.errors["fields." + index + ".name"]}
                          </span>
                        }
                      </div>
                      <div>
                        <label>Tipe Surat</label>
                        <br />
                        <Radio.Group
                          onChange={this.handleChangeField}
                          name={"field_type-" + index}
                          value={field.field_type}
                        >
                          <Radio value="text">Teks</Radio>
                          <Radio value="textarea">Teks Area</Radio>
                          <Radio value="file">File</Radio>
                        </Radio.Group>
                      </div>
                      {
                        <span className="error-message">
                          {this.state.errors["fields." + index + ".field_type"]}
                        </span>
                      }
                    </Col>
                    <Col style={{ position: "relative" }}>
                      <Tooltip title="Hapus field">
                        <Button
                          shape="circle"
                          type="danger"
                          style={{
                            position: "absolute",
                            top: 80,
                            marginLeft: 10,
                          }}
                          onClick={() => this.handleDeleteField(index)}
                        >
                          <DeleteOutlined />
                        </Button>
                      </Tooltip>
                    </Col>
                  </Row>
                ))}
              </Row>
            </Col>
            <Col className="card-form mt-10">
              <Row>
                <Col>
                  <h3>Fields Balasan</h3>{" "}
                </Col>
                <Col style={{ position: "absolute", right: 20 }}>
                  <Tooltip title="Tambah Field">
                    <Button
                      shape="circle"
                      className="add-button"
                      onClick={this.handleAddResponseField}
                    >
                      <PlusOutlined />
                    </Button>
                  </Tooltip>
                </Col>
              </Row>
              <Row className="mt-10">
                {form.response_fields.map((field, index) => (
                  <Row key={index}>
                    <Col className="mb-10" xs={22} sm={22} md={24} lg={18}>
                      <div>
                        <label>Label</label>
                        <Input
                          className="mb-5"
                          name={"label-" + index}
                          placeholder="label"
                          value={field.label}
                          onChange={this.handleChangeResponseField}
                        />
                        {
                          <span className="error-message">
                            {
                              this.state.errors[
                                "response_fields." + index + ".label"
                              ]
                            }
                          </span>
                        }
                      </div>
                      <div>
                        <label>Placeholder</label>
                        <Input
                          className="mb-5"
                          name={"placeholder-" + index}
                          placeholder="placeholder"
                          value={field.placeholder}
                          onChange={this.handleChangeResponseField}
                        />
                        {
                          <span className="error-message">
                            {
                              this.state.errors[
                                "response_fields." + index + ".placeholder"
                              ]
                            }
                          </span>
                        }
                      </div>
                      <div>
                        <label>Name</label>
                        <Input
                          className="mb-5"
                          name={"name-" + index}
                          placeholder="name"
                          value={field.name}
                          onChange={this.handleChangeResponseField}
                        />
                        {
                          <span className="error-message">
                            {
                              this.state.errors[
                                "response_fields." + index + ".name"
                              ]
                            }
                          </span>
                        }
                      </div>
                      <div>
                        <label>Tipe Surat</label>
                        <br />
                        <Radio.Group
                          onChange={this.handleChangeResponseField}
                          name={"field_type-" + index}
                          value={field.field_type}
                        >
                          <Radio value="text">Teks</Radio>
                          <Radio value="textarea">Teks Area</Radio>
                          <Radio value="file">File</Radio>
                        </Radio.Group>
                      </div>
                      {
                        <span className="error-message">
                          {
                            this.state.errors[
                              "response_fields." + index + ".field_type"
                            ]
                          }
                        </span>
                      }
                    </Col>
                    <Col style={{ position: "relative" }}>
                      <Tooltip title="Hapus field">
                        <Button
                          shape="circle"
                          type="danger"
                          style={{
                            position: "absolute",
                            top: 80,
                            marginLeft: 10,
                          }}
                          onClick={() => this.handleDeleteResponseField(index)}
                        >
                          <DeleteOutlined />
                        </Button>
                      </Tooltip>
                    </Col>
                  </Row>
                ))}
              </Row>
            </Col>
          </Col>

          <Col>
            <Col className="style-3 right">
              <div className="card-form mt-10">
                <Row>
                  <h3>Template</h3>
                  <a
                    href={
                      baseUrl +
                      "/letters/export-to-pdf/request/" +
                      this.state.letterID
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Tooltip title="Download template">
                      <Button
                        type="primary"
                        style={{ position: "absolute", right: 20 }}
                        shape="circle"
                        icon={<FilePdfOutlined />}
                      />
                    </Tooltip>
                  </a>
                </Row>

                <div>
                  Gunakan {"{{name}}"} untuk setiap variabel sesuai dengan field
                  yang telah diinput. <br />
                  Contoh: Nama saya {"{{name}}"}, saya berumur {"{{usia}}"}
                </div>
                <strong>Variabel umum:</strong>
                <br />
                <ul>
                  <li>Kop Surat: {"{{letterhead}}"}</li>
                  <li>
                    Ditujukan :
                    <ul>
                      <li>Jabatan : {"{{addressed.official}}"}</li>
                      <li>Nama : {"{{addressed.name}}"}</li>
                      <li>NIP : {"{{addressed.identity}}"}</li>
                      <li>NIP : {"{{addressed.signature}}"}</li>
                    </ul>
                  </li>
                  <li>
                    Data user yang sedang login:
                    <ul>
                      <li>NIM/NIP : {"{{user.identity}}"}</li>
                      <li>Nama User : {"{{user.name}}"}</li>
                      <li>Program Studi : {"{{user.major}}"}</li>
                      <li>Fakultas : {"{{user.faculty}}"}</li>
                      <li>Signature : {"{{user.signature}}"}</li>
                    </ul>
                  </li>
                  <li>
                    Tanggal Sekarang:
                    <ul>
                      <li>Full Date : {"{{date}}"}</li>
                      <li>Tanggal : {"{{date.day}}"}</li>
                      <li>Tanggal : {"{{date.mounth}}"}</li>
                      <li>Tanggal : {"{{date.year}}"}</li>
                    </ul>
                  </li>
                </ul>
                <div style={{ overflowX: "auto" }} className="style-3">
                  <Tabs defaultActiveKey="1" style={{ width: "212mm" }}>
                    <Tabs.TabPane
                      tab={
                        <span>
                          <FileOutlined />
                          Overview
                        </span>
                      }
                      key="1"
                      style={{ overflowY: "auto" }}
                      className="style-3"
                    >
                      <div>
                        <div style={{ height: 500 }}>
                          <div
                            className="overview"
                            dangerouslySetInnerHTML={{
                              __html: this.state.form.template,
                            }}
                          ></div>
                        </div>
                      </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={
                        <span>
                          <CodeOutlined /> Code
                        </span>
                      }
                      key="2"
                    >
                      <Col>
                        <Button
                          style={{ margin: 5 }}
                          onClick={() =>
                            this.handlePretty(
                              "template",
                              this.state.form.template
                            )
                          }
                        >
                          Pretty
                        </Button>
                        <TextArea
                          className="style-3"
                          value={this.state.form.template}
                          name="template"
                          rows={25}
                          onChange={this.handleChangeForm}
                        />
                      </Col>
                    </Tabs.TabPane>
                  </Tabs>
                </div>
              </div>
            </Col>

            <Col className="style-3 right">
              <div className="card-form mt-10">
                <Row>
                  <h3>Template Balasan</h3>

                  <a
                    href={
                      baseUrl +
                      "/letters/export-to-pdf/response/" +
                      this.state.letterID
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Tooltip title="Download Template">
                      <Button
                        type="primary"
                        style={{ position: "absolute", right: 20 }}
                        shape="circle"
                        icon={<FilePdfOutlined />}
                      />
                    </Tooltip>
                  </a>
                </Row>
                <div style={{ overflowX: "auto" }} className="style-3">
                  <Tabs defaultActiveKey="1" style={{ width: "212mm" }}>
                    <Tabs.TabPane
                      tab={
                        <span>
                          <FileOutlined />
                          Overview
                        </span>
                      }
                      key="1"
                      style={{ overflowY: "auto" }}
                      className="style-3"
                    >
                      <div>
                        <div style={{ height: 500 }}>
                          <div
                            className="overview"
                            dangerouslySetInnerHTML={{
                              __html: this.state.form.response_template,
                            }}
                          ></div>
                        </div>
                      </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={
                        <span>
                          <CodeOutlined /> Code
                        </span>
                      }
                      key="2"
                    >
                      <Col>
                        <Button
                          style={{ margin: 5 }}
                          onClick={() =>
                            this.handlePretty(
                              "response_template",
                              this.state.form.response_template
                            )
                          }
                        >
                          Pretty
                        </Button>
                        <TextArea
                          className="style-3"
                          value={this.state.form.response_template}
                          name="response_template"
                          rows={25}
                          onChange={this.handleChangeForm}
                        />
                      </Col>
                    </Tabs.TabPane>
                  </Tabs>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
        <Loading loading={this.props.loading} />
      </>
    );
  }
}

export default withRouter(withErrorHandler(AddLetter, Axios));
